export const integrationTypeOptions = [
  { value: "location", label: "Location" },
  { value: "account", label: "Account" },
];
